import { Box, Typography } from "@mui/material";
import { React } from "react";
import { Paper } from "@mui/material";

const InformationDialog = (props) => {
  const {
    text,
    actions,
    helperText,
    additionalActions,
    align = "center", // "center" | "left"
  } = props;
  return (
    <Paper
      sx={{
        background: "white",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: align === "left" ? "stretch" : "center",
        boxShadow: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            textAlign: align === "left" ? "left" : "center",
            width: "100%",
          }}
        >
          {text}
        </Typography>

        {actions && <Box sx={{ width: "100%" }}>{actions}</Box>}

        {helperText && (
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.99rem",
              textAlign: align === "left" ? "left" : "center",
              width: "100%",
            }}
          >
            {helperText}
          </Typography>
        )}

        {additionalActions && <Box sx={{ width: "100%",display: "flex", justifyContent: "center" }}>{additionalActions}</Box>}
      </Box>
    </Paper>
  );
};

export default InformationDialog;
